import { render, staticRenderFns } from "./SmartRewards.vue?vue&type=template&id=0419f035&scoped=true"
import script from "./SmartRewards.vue?vue&type=script&lang=js"
export * from "./SmartRewards.vue?vue&type=script&lang=js"
import style0 from "./SmartRewards.vue?vue&type=style&index=0&id=0419f035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419f035",
  null
  
)

export default component.exports